export const TARS_LANDING_PATH = "/tars";
export const TARS_BACK_TO_NOTEBOOKS_LABEL = "Back to notebooks";
export const TARS_NOTEBOOKS_LIST_STALE_MS = 0;
export const TARS_NOTEBOOK_LAST_TOUCHED_STORAGE_KEY = "tars-notebook-last-touched";
export const TARS_NOTEBOOK_CARD_HEIGHT_PX = 300;
export const TARS_NOTEBOOK_CARD_MIN_WIDTH_PX = 280;
export const TARS_NOTEBOOK_CARD_DATE_FORMAT = "MMM D, YYYY";
export const TARS_NOTEBOOK_CARD_UPDATED_LABEL = "Updated";
export const TARS_NOTEBOOK_CARD_UNKNOWN_DATE = "—";
export const TARS_NOTEBOOK_CARD_CANVAS_LABEL = "canvas";
export const TARS_NOTEBOOK_CARD_CANVASES_LABEL = "canvases";
export const TARS_NOTEBOOK_CARD_FACET_LABEL = "facet";
export const TARS_NOTEBOOK_CARD_FACETS_LABEL = "facets";
export const CANVAS_LIST_DEFAULT_LIMIT = 100;
export const CANVAS_LIST_DEFAULT_OFFSET = 0;
export const CANVAS_LIST_MAX_VISIBLE = 5;
export const CANVAS_LIST_ROW_HEIGHT_PX = 44;
export const CANVAS_LIST_SCROLL_MAX_HEIGHT_PX =
  CANVAS_LIST_MAX_VISIBLE * CANVAS_LIST_ROW_HEIGHT_PX;
export const CANVAS_CREATE_DEFAULT_VERSION = 1;
export const FACET_CREATE_DEFAULT_VERSION = 1;
export const FACET_UPDATE_DEFAULT_VERSION = 1;
export const TARS_CANVAS_LIST_PATH = "tars/canvas/list";
export const TARS_CANVAS_CREATE_PATH = "tars/canvas/create";
export const TARS_CANVAS_DELETE_PATH = "tars/canvas/delete";
export const TARS_FACETS_CREATE_PATH = "tars/facets_create";
export const TARS_FACETS_GET_PATH = "tars/facets_get";
export const TARS_FACETS_LIST_PATH = "tars/facets_list";
export const TARS_FACETS_DELETE_PATH = "tars/facets_delete";
export const TARS_FACETS_UPDATE_PATH = "tars/facets_update";
export const TARS_FACET_EXECUTE_ETL_PATH = "tars/facet_execute_etl";
export const TARS_FACETS_AUTOGENERATE_ETL_PATH = "tars/facets_autogenerate_etl";
export const FACET_AUTOGENERATE_CONFIRM_TITLE = "Generate facets automatically?";
export const FACET_AUTOGENERATE_CONFIRM_DESC =
  "Facets will be created automatically from your data source.";
export const FACET_AUTOGENERATE_CONFIRM_KEYS_HINT =
  "Select the Keys to Perform the Matrix Table";
export const FACET_AUTOGENERATE_CONFIRM_LABEL = "Yes";
export const FACET_AUTOGENERATE_SELECT_SOURCE_MSG =
  "Select a data repo data source in the sidebar before generating facets.";
export const FACET_AUTOGENERATE_LOADING_TITLE = "Generating facets";
export const FACET_AUTOGENERATE_LOADING_SUBTITLE =
  "This may take a moment. Please keep this tab open.";
export const FACET_AUTOGENERATE_COUNTDOWN_SECONDS = 30;
export const FACET_AUTOGENERATE_COUNTDOWN_HOLD_LABEL = "Almost there…";
export const FACET_AUTOGENERATE_LOADING_STEPS = [
  "Reading source fields",
  "Building matrix tables",
  "Configuring facet logic",
  "Preparing analytics view",
] as const;
export const FACET_AUTOGENERATE_LOADING_STEP_INTERVAL_MS = 3500;
export const FACET_MANUAL_CONFIRM_TITLE = "Add facet manually?";
export const FACET_MANUAL_CONFIRM_DESC =
  "A new empty facet will be created for the selected data source.";
export const FACET_MANUAL_CONFIRM_LABEL = "Yes";
export const TARS_CONTEXTS_GET_PATH = "tars/contexts/get";
export const TARS_CONTEXTS_CREATE_PATH = "tars/contexts/create";
export const TARS_CONTEXTS_LIST_PATH = "tars/contexts/list";
export const CONTEXTS_LIST_DEFAULT_LIMIT = 20;
export const TARS_ES_SAMPLE_DOC_PATH = "tars/es_sample-doc";
export const TARS_SOURCE_UPDATE_PATH = "tars/source/update";
export const TARS_PIVOT_TOTAL_LABEL = "Total";
export const FACET_LIST_MATRIX_ICON_COLOR = "#7c3aed";
export const FACET_LIST_NORMAL_ICON_COLOR = "#6b7280";
export const TARS_FACETS_S3_PREFIX = "tars/notebooks";
export const TARS_CHART_S3_CHARTS_SEGMENT = "charts";
export const TARS_CHART_IMAGE_CONTENT_TYPE = "image/png";
export const TARS_CHART_IMAGE_FILENAME_EXT = ".png";
export const TARS_CHART_IMAGE_SOURCE = "am5-export";
export const TARS_S3_PUBLIC_REGION = "ap-south-1";
export const TARS_CHART_ID_PREFIX = "chart_";
export const TARS_CHART_ID_RANDOM_LENGTH = 10;
export const TARS_CHART_PNG_EXPORT_MIN_WIDTH = 1920;
export const TARS_CHART_PNG_EXPORT_MIN_HEIGHT = 1080;
export const TARS_CHART_PUBLISH_SUCCESS_TOAST = "Chart pushed to cloud";
export const TARS_CHART_PUBLISH_MISSING_EXPORT =
  "Chart is not ready to export. Open Chart view first.";
export const TARS_CHART_PUBLISH_MISSING_NOTEBOOK =
  "Notebook id is required to push chart";
export const TARS_CHART_PUBLISH_UPLOAD_FAILED = "Failed to push chart image to cloud";
export const TARS_CHART_PUBLISH_BUTTON_LABEL = "Push chart";
export const TARS_CHART_PUBLISH_AGAIN_BUTTON_LABEL = "Push again";
export const TARS_CHART_PUBLISH_ARIA_LABEL =
  "Push chart image and metadata to cloud";
export const TARS_CHART_PUSHED_STATUS_LABEL = "Pushed to cloud";
export const TARS_CHART_NOT_PUSHED_STATUS_LABEL = "Not pushed";
export const TARS_CHART_LEFT_TO_PUSH_LABEL = "left to push";
